import {Banner} from '@primer/react'

export function SpammyBanner() {
  return (
    /* eslint-disable-next-line @github-ui/dotcom-primer/no-title-case -- baselined during linter rollout */
    <Banner variant="critical" title="Spammy Owner" description="The owner of this repository is flagged as spammy." />
  )
}
